const postfixes = {
  pcs: " шт.",
  rub: " ₽",
  percent: " %",
  volume: " л",
  day: " дн.",
  hour: " часа",
  pp: " п.п.",
};

// «»
const symbols = {
  none: "–",
  success: "✅",
  error: "❌",
  reverse_order: "-",
};

// это нужно для корректной предложки автозаполнения
const inputNames = {
  keyword: "search_keyword",
  cluster: "search_cluster",
  wb_token: "wb-token",
  wb_article: "wb_article",
  ozon_article: "ozon_article",
  ym_article: "ym_article",
  mm_article: "mm_article",
  wb_category: "wb_category",
  wb_subject: "wb_subject",
  wb_brand: "wb_brand",
  seller_article: "seller_article",
  barcode: "barcode",
  advert_companies: "advert_companies",
  product_id: "product_id",
  shk_id: "shk_id",
  month: "month",
  advert_keywords: "advert_keywords",
  cabinet_name: "cabinet_name",
  token: "token",
};

export { postfixes, symbols, inputNames };
